import type { TSimulacaoGrupoIntermediariasPrice } from '@/features/simulador/brasil/domain/schemas/simulacao-price.schema'

export class IntermediariasMapper {
  static transformPrice(intermediarias: TSimulacaoGrupoIntermediariasPrice | null | undefined) {
    if (!intermediarias?.grupos?.length) return []
    return intermediarias.grupos.map(({ valor, parcelas, ...rest }) => ({
      ...rest,
      percentualParticipacao: intermediarias.percentual,
      parcelas: parcelas.flatMap(({ data }) => (data ? [{ data, valor }] : [])),
    }))
  }
}
